import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function GlobalAnnouncement() {
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // localStorageから設定を読み込み
    const isActive = localStorage.getItem('dignia_global_alert_active') === 'true';
    const alertMessage = localStorage.getItem('dignia_global_alert') || '';
    
    // セッション中に閉じられたかチェック
    const dismissedSession = sessionStorage.getItem('dignia_alert_dismissed') === 'true';
    
    if (isActive && alertMessage && !dismissedSession) {
      setIsVisible(true);
      setMessage(alertMessage);
    }
  }, []);

  // 定期的にlocalStorageをチェック（管理画面での変更を反映）
  useEffect(() => {
    const interval = setInterval(() => {
      const isActive = localStorage.getItem('dignia_global_alert_active') === 'true';
      const alertMessage = localStorage.getItem('dignia_global_alert') || '';
      const dismissedSession = sessionStorage.getItem('dignia_alert_dismissed') === 'true';
      
      if (isActive && alertMessage && !dismissedSession) {
        setIsVisible(true);
        setMessage(alertMessage);
        setIsDismissed(false);
      } else if (!isActive) {
        setIsVisible(false);
      }
    }, 3000); // 3秒ごとにチェック

    return () => clearInterval(interval);
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    setIsVisible(false);
    // セッション中は非表示を維持
    sessionStorage.setItem('dignia_alert_dismissed', 'true');
  };

  if (!isVisible || isDismissed) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -100, opacity: 0 }}
        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        className="fixed top-0 left-0 right-0 z-[100] bg-gradient-to-r from-zinc-900 via-zinc-800 to-zinc-900 border-b-2 border-amber-500 shadow-2xl shadow-amber-500/20"
      >
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-start gap-4">
            {/* アイコン */}
            <div className="flex-shrink-0">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-amber-500 to-red-500 flex items-center justify-center shadow-lg shadow-amber-500/50 animate-pulse">
                <i className="ri-alert-line text-xl text-white"></i>
              </div>
            </div>

            {/* コンテンツ */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-amber-400 font-bold text-sm tracking-wider">⚠️ SYSTEM ALERT</span>
                <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse"></div>
              </div>
              <p className="text-white text-sm leading-relaxed whitespace-pre-wrap break-words">
                {message}
              </p>
            </div>

            {/* 閉じるボタン */}
            <button
              onClick={handleDismiss}
              className="flex-shrink-0 w-8 h-8 rounded-lg bg-zinc-700/50 hover:bg-zinc-600 transition-all duration-200 flex items-center justify-center group"
              aria-label="アラートを閉じる"
            >
              <i className="ri-close-line text-lg text-zinc-400 group-hover:text-white transition-colors"></i>
            </button>
          </div>
        </div>

        {/* ネオンボーダーエフェクト */}
        <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-amber-500 to-transparent animate-pulse"></div>
      </motion.div>
    </AnimatePresence>
  );
}